export const MODAL_ACTIONS = Object.freeze(
  /** @type {const} */ ({
    SHOW: 'show',
    HIDE: 'hide',
    REMOVE: 'remove',
    CLEAR: 'clear',
  })
);
